import { IPoint } from '@consts/types';

const isMouseEvent = (event: MouseEvent | TouchEvent): event is MouseEvent => {
  return !!(event as MouseEvent).offsetX;
}

export default (event: MouseEvent | TouchEvent): IPoint => {
  if (isMouseEvent(event)) {
    return {
      x: event.offsetX,
      y: event.offsetY
    }
  }

  return {
    x: event.touches[0].clientX,
    y: event.touches[0].clientY,
  }
}
